import * as cookie from "cookie";

import * as localConfig from "../constants/localConfig";
import * as config from "../constants/config";
import * as modules from "../constants/modules";
import * as platforms from "../constants/platforms";
import * as rcc from "../constants/rcc";
import * as componentTypes from "../constants/componentTypes";
import * as styles from "../constants/styles";
import * as getterHelper from "../helpers/getterHelper";
import * as modelHelper from "../helpers/modelHelper";

const remote = window.require === undefined ? null : window.require("@electron/remote");
const shutdown = window.require === undefined ? null : window.require("electron-shutdown-command");

export const getCurrentWindow = () => {
    if (remote !== null) {
        return remote.getCurrentWindow();
    }

    return null;
};

export const isBrowser = () => {
    if (remote === null) {
        return true;
    }

    return remote.getCurrentWindow() === null;
};

export const removeAllWindowListeners = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.removeAllListeners();
        }
    }
};

const updateConfig = (key, value) => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    return mainWindow.functions.updateConfig(key, value);
};

export const updateLocalConfig = (key, value) => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    return mainWindow.functions.updateLocalConfig(key, value);
};

export const getBasicSetup = () => {
    if (remote === null) {
        return localConfig.DEFAULT_BASIC_SETUP;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_BASIC_SETUP;
    }

    return mainWindow.functions.getLocalConfig().basicSetup;
};

export const setBasicSetup = (value) => {
    return updateLocalConfig("basicSetup", value);
};

export const restartRedlike = () => {
    if (remote !== null) {
        remote.app.relaunch();
        remote.app.exit(0);

        return true;
    }

    window.location.reload(true);
    return false;
};

export const rebootPc = () => {
    if (shutdown !== null) {
        shutdown.reboot();
    }
};

export const shutdownPc = () => {
    if (shutdown !== null) {
        shutdown.shutdown();
    }
};

export const closeWindow = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.close();
        }
    }
};

export const maximizeWindow = () => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    let result = false;
    if (mainWindow.isMaximized()) {
        result = mainWindow.functions.updateLocalConfig("maximized", false);

        if (result) {
            mainWindow.unmaximize();
        }

        return result;
    }

    result = mainWindow.functions.updateLocalConfig("maximized", true);

    if (result) {
        mainWindow.maximize();
    }

    return result;
};

export const minimizeWindow = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.minimize();
        }
    }
};

export const getParams = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.params;
};

export const getWindowWidth = () => {
    if (remote === null) {
        if (window.jQuery === undefined) {
            return 1201;
        }

        return window.jQuery("#root").width();
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        if (window.jQuery === undefined) {
            return 1201;
        }

        return window.jQuery("#root").width();
    }

    return mainWindow.getContentSize()[0];
};

export const getResolution = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return [mainWindow.params.screenWidth, mainWindow.params.screenHeight];
};

export const getScreenSaverTime = () => {
    if (remote === null) {
        return localConfig.DEFAULT_SCREENSAVER_TIME;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_SCREENSAVER_TIME;
    }

    return mainWindow.functions.getConfig().screenSaverTime;
};

export const setScreenSaverTime = (time) => {
    return updateConfig("screenSaverTime", time);
};

export const getScreenSaver = () => {
    if (remote === null) {
        return localConfig.DEFAULT_SCREENSAVER;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_SCREENSAVER;
    }

    return mainWindow.functions.getConfig().screenSaver;
};

export const setClientIdentifier = (identifier) => {
    return updateLocalConfig("clientIdentifier", identifier);
};

export const getClientIdentifier = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getLocalConfig().clientIdentifier;
};

export const getWeberCanBigLowerBound = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().canBigLowerBound;
};

export const getWeberCanBigUpperBound = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().canBigUpperBound;
};

export const getWeberCanCoatingLowerBound = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().canCoatingLowerBound;
};

export const getWeberCanCoatingUpperBound = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().canCoatingUpperBound;
};

export const getWeberCanLaboratoryLowerBound = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().canLaboratoryLowerBound;
};

export const getWeberCanLaboratoryUpperBound = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().canLaboratoryUpperBound;
};

export const getWeberCanSmallLowerBound = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().canSmallLowerBound;
};

export const getWeberCanSmallUpperBound = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().canSmallUpperBound;
};

export const getWeberCoatingNames = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().coatingNames;
};

export const getWeberPlasterNames = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().plasterNames;
};

export const getCustomColorantNames = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getConfig().customColorantNames;
};

export const getMaximized = () => {
    if (remote === null) {
        return true;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return true;
    }

    return mainWindow.functions.getLocalConfig().maximized;
};

export const getLogLevel = () => {
    if (remote === null) {
        return "error";
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return "error";
    }

    return mainWindow.functions.getConfig().logLevel;
};

export const setLogLevel = (logLevel) => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    mainWindow.functions.logInitialize(logLevel);

    return mainWindow.functions.updateConfig("logLevel", logLevel);
};

export const logMessage = (message) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.logMessage(message);
        }
    }
};

/**
 * @param   {String}    label   Unique string generated from md5 hash of function name
 * @param   {String}    message
 */
export const logError = (label, message) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.logError(label + ": " + message);
        }
    }
};

export const logWarn = (message) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.logWarn(message);
        }
    }
};

export const logInfo = (message) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.logInfo(message);
        }
    }
};

export const logDebug = (message) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.logDebug(message);
        }
    }
};

export const logRequest = (prefix, message) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.logRequest(prefix, message);
        }
    }
};

export const logResponse = (prefix, message, time) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.logResponse(prefix, message, time);
        }
    }
};

export const getLogPath = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getLogPath();
};

export const openDevTools = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.webContents.openDevTools();
        }
    }
};

export const isKioskActive = () => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    return mainWindow.isKiosk();
};

export const setKioskMode = (active) => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    if (mainWindow.functions.updateLocalConfig("kiosk", active)) {
        mainWindow.setKiosk(active);

        return true;
    }

    return false;
};

export const getSoftwareStyle = () => {
    if (remote === null) {
        if (localConfig.REDLIKE_LIGHT || localConfig.WEBER | localConfig.REDLIKE_LIGHT_AT_STARTUP) {
            return styles.REDLIKE_LIGHT_STYLE;
        }

        if (localConfig.GAMMA_FRONTDESK || localConfig.GAMMA_MACHINE) {
            return styles.GAMMA_STYLE;
        }

        return styles.REDLIKE_STYLE;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return styles.REDLIKE_STYLE;
    }

    if (mainWindow.functions.getLocalConfig().lightAtStartup) {
        return styles.REDLIKE_LIGHT_STYLE;
    }

    return getterHelper.getStyleBySoftware(mainWindow.functions.getLocalConfig().softwareType);
};

export const getCustomStyle = () => {
    if (remote === null) {
        if (localConfig.COLORIS) {
            return styles.COLORIS;
        }

        if (localConfig.WEBER) {
            return styles.WEBER;
        }

        if (styles.CUSTOM_STYLES.includes(localConfig.DEFAULT_STYLE)) {
            return localConfig.DEFAULT_STYLE;
        }

        return "";
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return "";
    }

    switch (mainWindow.functions.getLocalConfig().softwareType) {
        case modules.SOFTWARE_COLORIS:
            return styles.COLORIS;
        case modules.SOFTWARE_WEBER:
            return styles.WEBER;
        default:
            const style = mainWindow.functions.getConfig().style;

            if (styles.CUSTOM_STYLES.includes(style)) {
                return style;
            }

            for (let file of mainWindow.functions.getCustomStyleList()) {
                if (styles.CUSTOM_STYLES.includes(file)) {
                    return file;
                }
            }

            return "";
    }
};

export const setStyle = (style) => {
    return updateConfig("style", style);
};

export const getSoftwareType = () => {
    if (remote === null) {
        if (localConfig.REDLIKE_LIGHT) {
            return modules.SOFTWARE_LIGHT;
        }

        if (localConfig.GAMMA_FRONTDESK || localConfig.GAMMA_MACHINE) {
            return modules.SOFTWARE_GAMMA;
        }

        if (localConfig.WEBER) {
            return modules.SOFTWARE_WEBER;
        }

        if (localConfig.COLORIS) {
            return modules.SOFTWARE_COLORIS;
        }

        return modules.SOFTWARE_REDLIKE;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return modules.SOFTWARE_REDLIKE;
    }

    return mainWindow.functions.getLocalConfig().softwareType;
};

export const getBuildVersion = () => {
    if (remote === null) {
        return modules.BUILD_DEV;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return modules.BUILD_DEV;
    }

    return mainWindow.params.buildVersion;
};

export const getBuildRevision = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.params.buildRevision;
};

export const getLightAtStartup = () => {
    if (remote === null) {
        return localConfig.REDLIKE_LIGHT_AT_STARTUP;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.REDLIKE_LIGHT_AT_STARTUP;
    }

    return mainWindow.functions.getLocalConfig().lightAtStartup;
};

export const setLightAtStartup = (value) => {
    return updateLocalConfig("lightAtStartup", value);
};

export const getModule = () => {
    if (remote === null) {
        if (localConfig.GAMMA_FRONTDESK) {
            return modules.MODULE_FRONTDESK;
        }

        if (localConfig.GAMMA_MACHINE) {
            return modules.MODULE_MACHINE;
        }

        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getLocalConfig().module;
};

export const setModule = (module) => {
    return updateLocalConfig("module", module);
};

export const getLanguage = () => {
    if (remote === null) {
        return localConfig.DEFAULT_LANGUAGE;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_LANGUAGE;
    }

    return mainWindow.functions.getLocalConfig().lang;
};

export const setLanguage = (language) => {
    updateLocalConfig("lang", language);

    return true;
};

export const getLockComputer = () => {
    if (remote === null) {
        return localConfig.DEFAULT_LOCK_COMPUTER;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_LOCK_COMPUTER;
    }

    return mainWindow.functions.getLocalConfig().lockComputer;
};

export const setLockComputer = (value) => {
    return updateLocalConfig("lockComputer", value);
};

export const getDefaultServer = () => {
    if (isBrowser()) {
        const cookies = cookie.parse(document.cookie);

        if (cookies["server"] !== undefined) {
            return cookies["server"];
        }

        if (window.location.hostname.length === 0) {
            return localConfig.DEFAULT_SERVER;
        }

        return window.location.hostname;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_SERVER;
    }

    return mainWindow.functions.getLocalConfig().server;
};

export const setDefaultServer = (ip) => {
    return updateLocalConfig("server", ip);
};

export const setDefaultServerByUrl = (rawUrl) => {
    let url = rawUrl.substring(5);

    if (url.indexOf(":") === -1) {
        return true;
    }

    let urlParts = url.split(":");

    if (urlParts.length !== 2) {
        return true;
    }

    if (urlParts[0] === "" || urlParts[0] === getDefaultServer()) {
        return true;
    }

    if (remote === null) {
        document.cookie = cookie.serialize("server", urlParts[0], {maxAge: 60 * 60 * 24 * 400});
        return true;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return true;
    }

    return mainWindow.functions.updateLocalConfig("server", urlParts[0]);
};

export const getDefaultRcc = () => {
    if (isBrowser()) {
        const cookies = cookie.parse(document.cookie);

        if (cookies["rcc"] !== undefined) {
            return cookies["rcc"];
        }

        if (window.location.hostname.length === 0) {
            return localConfig.DEFAULT_RCC;
        }

        return window.location.hostname;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_RCC;
    }

    return mainWindow.functions.getLocalConfig().rcc;
};

export const setDefaultRcc = (ip) => {
    if (remote === null) {
        document.cookie = cookie.serialize("rcc", ip, {maxAge: 60 * 60 * 24 * 400});
        return true;
    }

    return updateLocalConfig("rcc", ip);
};

export const closeMulticastSocket = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.closeMulticastSocket();
        }
    }
};

export const refreshMulticastServerList = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.refreshMulticastServerList();
        }
    }
};

export const getMulticastServerList = () => {
    if (remote === null) {
        return [];
    }
    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return [];
    }

    return mainWindow.functions.getMulticastServerList();
};

export const loadCustomTranslations = (supportedLanguages, callback) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.loadCustomTranslations(supportedLanguages, callback);
        } else {
            callback();
        }
    } else {
        callback();
    }
};

export const getCustomTranslations = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getCustomTranslations();
};

export const writeVersionFile = (name, code, version) => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    return mainWindow.functions.writeVersionFile(name, code, version);
};

export const getCustomLanguages = () => {
    if (remote === null) {
        return {};
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return {};
    }

    return mainWindow.functions.getConfig().lang;
};

export const getLocalhosts = () => {
    let ipList = [config.LOCALHOST];

    if (remote === null) {
        return ipList;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return ipList;
    }

    let interfaces = mainWindow.functions.getLocalInterfaces();

    if (typeof interfaces !== "object" || interfaces === null) {
        return ipList;
    }

    let ip;
    for (let key in interfaces) {
        if (Array.isArray(interfaces[key])) {
            for (ip of interfaces[key]) {
                ipList.push(ip.address);
            }
        }
    }

    return ipList;
};

export const isLocalhost = (ip) => {
    return getLocalhosts().includes(ip);
};

export const getScreenSaverImageList = () => {
    if (remote === null) {
        return [];
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return [];
    }

    return mainWindow.functions.getScreenSaverImageList();
};

export const getScreenSaverInterval = () => {
    if (remote === null) {
        return 10;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return 10;
    }

    return mainWindow.functions.getConfig().screenSaverInterval;
};

export const getBannerImageList = () => {
    if (remote === null) {
        return [];
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return [];
    }

    return mainWindow.functions.getBannerImageList();
};

export const getCustomStylePath = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    if (mainWindow.params.platform === "linux") {
        return "/home/" + mainWindow.params.user.username + "/Deso/redlike/client/style/style.css";
    }

    if (mainWindow.params.platform === "win32") {
        return "C:\\ProgramData\\Deso\\redlike\\client\\style\\style.css";
    }

    return null;
};

export const isWindows = () => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    return mainWindow.params.platform === "win32";
};

export const isDebugMode = () => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    return mainWindow.params.debugMode;
};

export const getDefaultDatabase = () => {
    if (remote === null) {
        return localConfig.DEFAULT_DATABASE;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_DATABASE;
    }

    return mainWindow.functions.getLocalConfig().database;
};

export const setDefaultDatabase = (databaseName) => {
    return updateLocalConfig("database", databaseName);
};

export const openSaveDialog = (data, defaultValue) => {
    if (remote !== null) {
        remote.dialog.showSaveDialog({defaultPath: defaultValue}).then((result) => {
            if (!result.canceled) {
                /* eslint-disable-next-line no-undef */
                window.require("fs").writeFile(result.filePath, Buffer.from(data, "base64"), function (err) {
                    if (err !== null) {
                        logError("4C12272E6E7F926", err.message);
                    }
                });
            }
        });
    }
};

export const openSaveFileDialog = (defaultValue, callback) => {
    if (remote !== null) {
        remote.dialog.showSaveDialog({defaultPath: defaultValue}).then((result) => {
            if (!result.canceled) {
                callback(result.filePath);
            }
        });
    }
};

export const openSaveTextFileDialog = (data, defaultValue) => {
    if (remote !== null) {
        remote.dialog.showSaveDialog({defaultPath: defaultValue}).then((result) => {
            if (!result.canceled) {
                window.require("fs").writeFile(result.filePath, data, function (err) {
                    if (err !== null) {
                        logError("915FE8A8141C4E5", err.message);
                    }
                });
            }
        });
    }
};

export const openMoveFileDialog = (sourceFile, defaultFileName) => {
    if (remote !== null) {
        remote.dialog.showSaveDialog({defaultPath: defaultFileName}).then((result) => {
            if (!result.canceled) {
                let mainWindow = remote.getCurrentWindow();

                if (mainWindow !== null) {
                    mainWindow.functions.fileMoveTo(sourceFile, result.filePath, (err) => {
                        if (err !== null) {
                            logError("0E4812933DF3ACF", err.message);
                        }
                    });
                }
            }
        });
    }
};

export const readTextFile = (filePath, callback) => {
    try {
        if (!window.require("fs").existsSync(filePath)) {
            callback(null);
            return false;
        }

        callback(String(window.require("fs").readFileSync(filePath)));
    } catch (e) {
        callback(null);
    }

    return true;
};

export const copyFilesFromTo = (fromPath, toPath) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.functions.fileCopyTo(fromPath, toPath, (err) => {
                if (err !== null) {
                    logError("19C8D19B99F2445", err.message);
                }
            });
        }
    }
};

export const getRccTemplatesPath = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            return mainWindow.functions.getRccTemplatesPath();
        }

        return "";
    }

    return "";
};

export const openSelectFilesDialog = (callback, type = null) => {
    if (remote !== null) {
        let filters = [];
        if (type === null) {
            filters = [
                {
                    name: "jpg, jpeg, png",
                    extensions: ["jpg", "png", "jpeg"]
                },
                {
                    name: "zip",
                    extensions: ["zip"]
                }
            ];
        }
        if (type === "template") {
            filters = [
                {
                    name: "fr3",
                    extensions: ["fr3"]
                }
            ];
        }
        remote.dialog
            .showOpenDialog({
                properties: ["multiSelections", "openFile"],
                filters: filters
            })
            .then((result) => {
                if (!result.canceled) {
                    callback(result);
                }
            });
    }
};

export const appendFileData = (defaultPath, data, callback) => {
    if (remote !== null) {
        /* eslint-disable-next-line no-undef */
        let dataReference = Buffer.from(data, "base64");
        remote.require("fs").appendFile(defaultPath, dataReference, callback);
    }
};

export const getTempPathForCustomFileName = (name) => {
    if (remote === null) {
        return "";
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return "";
    }

    return mainWindow.functions.getTempPathForCustomFileName(name);
};

export const openSelectFileDialog = (path, callback, filters) => {
    if (remote !== null) {
        remote.dialog
            .showOpenDialog({
                defaultPath: path,
                filters: [
                    {
                        name: filters.join(", "),
                        extensions: filters
                    }
                ],
                properties: ["openFile"]
            })
            .then((result) => {
                if (!result.canceled) {
                    callback(result.filePaths[0]);
                }
            });
    }
};

export const openSelectDirectoryDialog = (callback) => {
    if (remote !== null) {
        remote.dialog.showOpenDialog({properties: ["openDirectory"]}).then((result) => {
            if (!result.canceled) {
                callback(result.filePaths[0]);
            }
        });
    }
};

export const getHelpMessage = () => {
    if (remote === null) {
        return localConfig.DEFAULT_HELP;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_HELP;
    }

    return mainWindow.functions.getHelpMessage();
};

export const isPrintTemplateEditorAvailable = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            return mainWindow.functions.isPrintTemplateEditorAvailable();
        }
    }

    return false;
};

export const openPrintTemplateEditor = (arg, callback) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            return mainWindow.functions.openPrintTemplateEditor(arg, callback);
        }
    }

    return false;
};

export const openHelpPdfWindow = () => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            return mainWindow.functions.openHelpPdf();
        }
    }

    return false;
};

export const getRccHelpPath = (lang) => {
    if (remote !== null) {
        let mainWindow = remote.getCurrentWindow();

        if (mainWindow !== null) {
            return mainWindow.functions.getRccHelpPath(lang);
        }
    }

    return null;
};

export const getRccHelpMessage = (lang, machineType, message, messageCode) => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    if (rcc.RCC_MESSAGE_AUTOTASKS.includes(message)) {
        return mainWindow.functions.getRccHelpMessage(lang, machineType, message, messageCode);
    }

    return null;
};

const openBrowserFullScreen = () => {
    if (document.fullscreenElement !== null) {
        return false;
    }

    if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
    }

    return true;
};

const exitBrowserFullScreen = () => {
    if (document.fullscreenElement === null) {
        return false;
    }

    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    }

    return true;
};

export const switchKioskMode = (kioskMode) => {
    if (isBrowser()) {
        if (kioskMode) {
            exitBrowserFullScreen();
            return true;
        }

        openBrowserFullScreen();
        return true;
    }

    setKioskMode(!kioskMode);

    return true;
};

export const getPlugins = () => {
    if (remote === null) {
        return localConfig.DEFAULT_PLUGINS;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_PLUGINS;
    }

    return mainWindow.functions.getConfig().plugins;
};

export const setWinterPlugin = (active) => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    let plugins = getPlugins();

    if (plugins === undefined || plugins === null || typeof plugins !== "object") {
        plugins = {
            winter: false
        };
    }

    plugins.winter = active;

    return mainWindow.functions.updateConfig("plugins", JSON.stringify(plugins));
};

export const getTutorial = () => {
    if (remote === null) {
        return [];
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return [];
    }

    return mainWindow.functions.getLocalConfig().tutorial;
};

export const finishTutorial = (tutorial) => {
    return updateLocalConfig("tutorial", getTutorial().concat([tutorial]));
};

export const getIgnoredConfirmations = () => {
    if (remote === null) {
        return [];
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return [];
    }

    return mainWindow.functions.getLocalConfig().ignoredConfirmations;
};

export const addIgnoredConfirmation = (action) => {
    return updateLocalConfig("ignoredConfirmations", getIgnoredConfirmations().concat([action]));
};

export const getCollapsedFandeckGroups = () => {
    if (remote === null) {
        return [];
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return [];
    }

    return mainWindow.functions.getLocalConfig().collapsedFandeckGroups;
};

export const setCollapsedFandeckGroups = (groups) => {
    return updateLocalConfig("collapsedFandeckGroups", groups);
};

export const getCollapsedProductGroups = () => {
    if (remote === null) {
        return [];
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return [];
    }

    return mainWindow.functions.getLocalConfig().collapsedProductGroups;
};

export const setCollapsedProductGroups = (groups) => {
    return updateLocalConfig("collapsedProductGroups", groups);
};

export const getPingInterval = () => {
    if (remote === null) {
        return localConfig.DEFAULT_PING_INTERVAL;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return localConfig.DEFAULT_PING_INTERVAL;
    }

    return config.WEBSOCKET_PING_INTERVAL;
};

export const getProcessStatistics = () => {
    if (remote === null) {
        return null;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return null;
    }

    return mainWindow.functions.getProcessStatistics();
};

export const getPlatform = () => {
    if (remote === null) {
        return platforms.BROWSER;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return platforms.BROWSER;
    }

    return isWindows() ? platforms.WINDOWS : platforms.LINUX;
};

export const isInsufficientDiskSpace = () => {
    if (remote === null) {
        return false;
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return false;
    }

    return mainWindow.functions.isInsufficientDiskSpace();
};

export const saveOpenedTabs = (tabList, formulaStore) => {
    let openedTabs = [];

    for (let openTab of tabList) {
        if (
            openTab.type !== componentTypes.FAVORITES_TAB &&
            openTab.type !== componentTypes.BUG_REPORT_TAB &&
            openTab.type !== componentTypes.GLOBAL_SEARCH_TAB &&
            openTab.type !== componentTypes.ORDERS_HISTORY_TAB
        ) {
            if (getterHelper.isFormulaTab(openTab.type)) {
                if (formulaStore[openTab.id] !== undefined && formulaStore[openTab.id].active) {
                    openedTabs.push({
                        type: openTab.type,
                        product: modelHelper.serializeProduct(formulaStore[openTab.id].product),
                        fandeck: modelHelper.serializeFandeck(formulaStore[openTab.id].fandeck),
                        color: modelHelper.serializeColor(formulaStore[openTab.id].color),
                        base: modelHelper.serializeBase(formulaStore[openTab.id].base)
                    });
                }
            } else {
                openedTabs.push({
                    type: openTab.type,
                    product: null,
                    fandeck: null,
                    color: null,
                    base: null
                });
            }
        }
    }

    return updateLocalConfig("tabs", openedTabs);
};

export const getOpenedTabs = () => {
    if (remote === null) {
        return [];
    }

    let mainWindow = remote.getCurrentWindow();

    if (mainWindow === null) {
        return [];
    }

    return mainWindow.functions.getLocalConfig().tabs;
};
